// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const furfrou: PokeData = {
  "id": 676,
  "name": "furfrou",
  "height": 12,
  "weight": 280,
  "base_experience": 165,
  "types": [
    PokeType.NORMAL
  ],
  "api_moves": [
    "sand-attack",
    "headbutt",
    "tackle",
    "take-down",
    "tail-whip",
    "bite",
    "growl",
    "charm",
    "odor-sleuth",
    "sucker-punch",
    "retaliate",
    "cotton-guard",
    "baby-doll-eyes"
  ],
  "moves": [
    "headbutt",
    "tackle",
    "bite",
    "growl",
    "refresh",
    "leer",
    "scary-face",
    "purification",
    "scratch",
    "quick-attack",
    "splash",
    "protect",
    "body-slam"
  ],
  "evolution_chain": {
    "id": 347,
    "item": null,
    "species": [
      {
        "name": "furfrou",
        "order": 677,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 117,
    "speed": 159,
    "ability_power": 125
  },
  "stat_changes": [],
  "catch_rate": 160,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
